import React, { useState, useContext, useEffect, useRef, forwardRef, useImperativeHandle, memo } from 'react';
import Button from '@mui/material/Button';
import {

    Box,
    Grid2 as Grid,
    DialogTitle,
    Tooltip,
    ButtonGroup,
    Stepper,
    StepButton,
    Step,
    Checkbox,
    Typography,
    MenuItem,
    ListItemIcon,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';



import { Add, AddBox, AddCircle, AutoFixHigh, Block, CheckBoxOutlineBlank, ChevronRight, Close, ColorLens, Delete, Edit, Functions, InsertLink, LibraryAddCheck, Link, PlusOne, Repartition, Save, } from '@mui/icons-material';

import { myTimestampToDate, propComparatorDate, propComparatorDateTime } from '../utils/ui_utils';
import { useAuth } from '../core/AuthProvider';
import { addMinutes, differenceInMinutes, format, subMinutes } from 'date-fns';
import { globalstyles } from '../lib/definitions';
import { useEvent } from '../context/eventContext';

const newmatch_settings = {
    min_count: 2,
    max_count: 35,
    duration: 30,
    planned_start: new Date()
}




export const CowSqualifiedDialog = forwardRef(({ cow_list, editFn }, ref) => {
    const { selEvent } = useEvent()

    const [open, setOpen] = useState(false);
    const [curElement, setCurElement] = useState({ ...newmatch_settings, planned_start: selEvent.event_start || new Date() })
    const [match_list, setMatchList] = useState([])
    const [squalified, setSqualified] = useState()
    useImperativeHandle(ref, () => {
        return {
            onOpen(ml) {
                setMatchList(ml)
                handleOpen()
            }
        }
    })


    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = async () => {
        setOpen(false);
    };


    const correctMatch = (m) => {
        let _m = {...m}
        _m.original_result_list = [...m.result_list]
        _m.cow_list = m.cow_list.map(c => {
            if (c.id === squalified.cow.id){
                return {...c, squalified: true}
            }else{
                return c
            }
        })
    }

    const handleSave = () => {

        editFn()
        setOpen(false);
    }



    const initData = async () => {

    }



    const handleSqualified = (c) => {
        setSqualified({ cow: c, match_list: match_list.filter(m => m.cow_list.map(_c => _c.id).includes(c.id)) })
    }




    return (
        <Dialog open={open} onClose={() => handleClose()} fullScreen={true}>
            <DialogTitle>
                Squalifica soggetto {squalified && <Button size="small" variant="outlined" onClick={() => setSqualified(undefined)}>cerca soggetto</Button>}
            </DialogTitle>
            <DialogContent>
                {squalified ?
                    <Grid>
                        <Grid container style={globalstyles.sectionHeader}>
                            soggetto da qualificare
                        </Grid>
                        <Grid container style={globalstyles.listHeader}>
                            <Grid size={1}>
                                catalogo
                            </Grid>
                            <Grid size={1}>
                                matricola
                            </Grid>
                            <Grid size={2}>
                                nome
                            </Grid>
                            <Grid size={4}>
                                proprietà
                                <Box sx={{ color: 'grey', fontStyle: 'italic' }}>coproprietà</Box>
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid size={1}>
                                {squalified.cow.catalog_id}
                            </Grid>
                            <Grid size={1}>
                                {squalified.cow.serial}
                            </Grid>
                            <Grid size={2}>
                                {squalified.cow.name}
                            </Grid>
                            <Grid size={4}>
                                {squalified.cow.property?.name}
                                <Box sx={{ color: 'grey', fontStyle: 'italic' }}>{squalified.cow.coproperty}</Box>
                            </Grid>
                        </Grid>
                        <Grid container style={globalstyles.sectionHeader}>
                            Gare interessate
                        </Grid>
                        <Grid style={globalstyles.listHeader}>
                            <Grid container>
                                <Grid size={3}>
                                    Gara
                                </Grid>
                                <Grid size="grow">
                                    <Grid container size="grow">
                                        <Grid size={3}>
                                            Premio
                                        </Grid>
                                        <Grid>
                                            posizione
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>

                        </Grid>
                        {squalified.match_list.map((m, k) => (
                            <Grid key={k} container>
                                <Grid size={3}>
                                    {m.match_name}
                                </Grid>
                                <Grid size="grow">
                                    {m.result_list.map((r, rk) => {
                                        return (
                                            <Grid key={rk} container size="grow" style={globalstyles.list_row}>
                                                <Grid size={3}>
                                                    {r.award_name}
                                                </Grid>
                                                <Grid>

                                                    {r.cow_list.map((cr, crk) => {
                                                        if (cr.cow && cr.cow.id === squalified.cow.id) {
                                                            return (
                                                                <Grid key={crk}>
                                                                    {crk + 1}
                                                                </Grid>
                                                            )
                                                        }
                                                    })}
                                                </Grid>
                                            </Grid>
                                        )
                                    })}
                                </Grid>
                            </Grid>
                        ))}
                    </Grid>
                    :
                    cow_list.sort(propComparatorDate('birthdate', true, 'catalog_id')).filter(c => c.is_present).map((c, k) => (
                        <OneCow
                            key={k}
                            cow={c}
                            match_list={match_list.filter(m => m.cow_list.map(_c => _c.id).includes(c.id))}
                            handleSqualified={() => handleSqualified(c)}
                        />
                    ))}
            </DialogContent>
            <DialogActions>
                <Button variant='outlined' key={'bc'} onClick={handleClose}>Chiudi</Button>
                <Button disabled={true} key={'bs'} onClick={handleSave} startIcon={<Save />} variant="contained" color="secondary" >Concludi procedura </Button>
            </DialogActions>
        </Dialog>
    );
})


const OneCow = ({ cow, match_list, handleSqualified }) => {

    return (
        <Grid container style={{ ...globalstyles.list_row, ...globalstyles.elem_row }}>
            <Grid size={1}>
                {cow.catalog_id}
            </Grid>
            <Grid size={2}>
                {cow.serial}
            </Grid>
            <Grid size={2}>
                {cow.name}
            </Grid>
            <Grid size={"grow"}>
                {match_list.map((m, k) => (
                    <Grid container key={k}>
                        {m.match_name}
                    </Grid>
                ))}
            </Grid>
            <Grid size={"auto"}>
                <Button variant="outlined" size="small" onClick={handleSqualified}>
                    <Block /> squalifica
                </Button>
            </Grid>
        </Grid>
    )

}